import { supabase } from '@/integrations/supabase/client';

export interface Supplier {
  id: string;
  name: string;
  code: string;
  contact_email: string | null;
}

export interface CreateSupplierInput {
  tenant_id: string;
  factory_id: string;
  name: string;
  code: string;
  contact_email?: string | null;
}

export interface UpdateSupplierInput {
  name: string;
  code: string;
  contact_email?: string | null;
}

export async function fetchSuppliersByFactory(
  tenantId: string,
  factoryId: string,
): Promise<Supplier[]> {
  const { data, error } = await supabase
    .schema('mod_8d')
    .from('suppliers')
    .select('id, name, code, contact_email')
    .eq('tenant_id', tenantId)
    .eq('factory_id', factoryId)
    .order('name');

  if (error) throw error;
  return (data ?? []) as Supplier[];
}

export async function createSupplier(input: CreateSupplierInput): Promise<Supplier> {
  const { data, error } = await supabase
    .schema('mod_8d')
    .from('suppliers')
    .insert({
      tenant_id: input.tenant_id,
      factory_id: input.factory_id,
      name: input.name,
      code: input.code,
      contact_email: input.contact_email ?? null,
      is_active: true,
    })
    .select('id, name, code, contact_email')
    .single();

  if (error) throw error;
  return data as Supplier;
}

export async function updateSupplier(
  id: string,
  tenantId: string,
  factoryId: string,
  input: UpdateSupplierInput,
): Promise<Supplier> {
  const { data, error } = await supabase
    .schema('mod_8d')
    .from('suppliers')
    .update({
      name: input.name,
      code: input.code,
      contact_email: input.contact_email ?? null,
    })
    .eq('id', id)
    .eq('tenant_id', tenantId)
    .eq('factory_id', factoryId)
    .select('id, name, code, contact_email')
    .single();

  if (error) throw error;
  return data as Supplier;
}
